<template>
	<span class="event-color-field likeInput" :class="{ 'read-only': readonly }" :tabindex="tabindex" ref="fieldSpan">x
		<span class="event-color-field-fill" :style="colorStyle"></span>
		<span v-if="value === 0" class="event-color-cross"></span>
	</span>
</template>

<script setup lang="ts">

import {computed, type CSSProperties, ref} from "vue";

const props = withDefaults(defineProps<{
	value:number;
	tabindex?:number;
	readonly?:boolean;
}>(), { tabindex: 0, readonly:false });

const EVENT_COLORS = ["--input-bg", "--red-bg","--orange-bg","--yellow-bg","--light-green-bg","--dark-green-bg",
	"--green-blue-bg","--cyan-bg","--blue-bg","--dark-blue-bg","--purple-bg","--magenta-bg","--salmon-bg"];

const colorStyle = computed<CSSProperties>(() => {
	const css:CSSProperties = {};
	let v = props.value;
	if (v < 0 || v >= EVENT_COLORS.length) v = 0;
	css['--bg'] = "var(" + EVENT_COLORS[v] + ")";
	return css;
});

const fieldSpan = ref<HTMLSpanElement|null>(null);

defineExpose({ fieldSpan });
</script>

<style>
.event-color-field.likeInput {
	box-sizing: border-box;
	display: inline-block;
	vertical-align: baseline;
	width: 60px;
	color: transparent !important; /* Hide the x character (it's there because of baseline alignment) */
	position: relative;

	background-image: var(--select-caret), linear-gradient(to bottom, var(--select-top-bg), var(--select-bottom-bg));
	background-size: 16px 16px, 16px 100%;
	background-repeat: no-repeat, no-repeat;
	background-position: right center, right center;
}
.event-color-field.read-only {
	background-image: none;
	width: 44px;

	& > .event-color-field-fill {
		right: 2px;
	}
}
.event-color-field-fill {
	background-color: var(--bg);
	position: absolute;
	top: 2px;
	left: 2px;
	bottom: 2px;
	right: 18px;
	transition: background-color 300ms;
	z-index: 10;
}
.event-color-cross {
	position: absolute;
	display: inline-block;
	height: 2px;
	width: 39px;
	top: calc(var(--input-height) - 6px);
	left: 4px;
	transform-origin: 2px 2px;
	transform: rotate(-20deg);
	background-color: #808080;
	z-index: 20;
	opacity: 0.25;
}
</style>